export default {
  head: {
    link: [
      {
        rel: 'preconnect',
        href: 'https://fonts.googleapis.com',
      },
      {
        rel: 'preconnect',
        href: 'https://fonts.gstatic.com',
      },
      {
        rel: 'preload',
        href: 'https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu7GxKKTU1Kvnz.woff2',
        as: 'font',
        type: 'font/woff2',
        crossorigin: true,
      },
      {
        rel: 'preload',
        href: 'https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu4mxKKTU1Kg.woff2',
        as: 'font',
        type: 'font/woff2',
        crossorigin: true,
      },
      {
        rel: 'preload',
        href: 'https://fonts.cdnfonts.com/s/14898/GothamBook.woff',
        as: 'font',
        type: 'font/woff',
        crossorigin: true,
      },
      {
        rel: 'preload',
        href: 'https://fonts.cdnfonts.com/s/14898/GothamMedium_1.woff',
        as: 'font',
        type: 'font/woff',
        crossorigin: true,
      },
      {
        rel: 'preload',
        href: 'https://fonts.cdnfonts.com/s/14898/Gotham-Bold.woff',
        as: 'font',
        type: 'font/woff',
        crossorigin: true,
      },
    ],
  },
}
